if (!customElements.get('is-socks-pack')) {
  const selected = new Map();
  customElements.define('is-socks-pack', class extends HTMLElement {
    connectedCallback() {
      const key = this.dataset.productId;
      const value = selected.get(key) || '1';
      const radio = this.querySelector('input[value="' + value + '"]');
      if (radio) radio.checked = true;
      const section = this.closest('.shopify-section');
      const updatePrice = () => {
        const quantity = this.querySelector('input[name="quantity"]:checked')?.value || '1';
        section?.querySelectorAll('product-price[data-product-id="' + key + '"] [data-socks-price]').forEach((container) => {
          const price = quantity === '3' ? container.dataset.packPrice : container.dataset.singlePrice;
          container.querySelectorAll('.price').forEach((node) => {
            if (price && node.textContent !== price) node.textContent = price;
          });
        });
      };
      this.onchange = (event) => {
        if (event.target.name === 'quantity') {
          selected.set(key, event.target.value);
          updatePrice();
        }
      };
      this.priceObserver?.disconnect();
      this.priceObserver = new MutationObserver(updatePrice);
      if (section) this.priceObserver.observe(section, { childList: true, subtree: true, characterData: true });
      updatePrice();
    }
    disconnectedCallback() {
      this.priceObserver?.disconnect();
    }
  });
}